import apiClient, { safeJson } from '@/api/client';
import {
    IFacilityProduct,
    CreateFacilityProductBody,
    UpdateFacilityProductBody,
    FacilityProductListResponse,
} from './types';

/**
 * @method get
 * @brief 시설 상품 목록 조회
 */
export const getFacilityProducts = async ({ centerId }: { centerId: string }) => {
    const res = await apiClient.get(`v1/centers/${centerId}/facility-products`, {
        searchParams: { includeInactive: 'true' },
    });
    const data = await safeJson(res);
    return {
        status: res.status,
        data: data as FacilityProductListResponse | null,
    };
};

/**
 * @method post
 * @brief 시설 상품 생성
 */
export const createFacilityProduct = async ({
    centerId,
    body,
}: {
    centerId: string;
    body: CreateFacilityProductBody;
}) => {
    const res = await apiClient.post(`v1/centers/${centerId}/facility-products`, {
        json: body,
    });
    const data = await safeJson(res);
    return {
        status: res.status,
        data: data as IFacilityProduct | null,
    };
};

/**
 * @method put
 * @brief 시설 상품 수정
 */
export const updateFacilityProduct = async ({
    centerId,
    productId,
    body,
}: {
    centerId: string;
    productId: string;
    body: UpdateFacilityProductBody;
}) => {
    const res = await apiClient.put(`v1/centers/${centerId}/facility-products/${productId}`, {
        json: body,
    });
    const data = await safeJson(res);
    return {
        status: res.status,
        data: data as IFacilityProduct | null,
    };
};

/**
 * @method delete
 * @brief 시설 상품 삭제
 */
export const deleteFacilityProduct = async ({
    centerId,
    productId,
}: {
    centerId: string;
    productId: string;
}) => {
    const res = await apiClient.delete(`v1/centers/${centerId}/facility-products/${productId}`);
    const data = await safeJson(res);
    return {
        status: res.status,
        data: data as { success: boolean } | null,
    };
};
